var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "date-input-wrapper", class: { error: _vm.error } },
    [
      _c("flat-pickr", {
        attrs: {
          id: "effectiveDate",
          placeholder: _vm.placeholder,
          config: _vm.config
        },
        on: {
          input: _vm.changed,
          "on-open": function($event) {
            _vm.$emit("focus")
          },
          "on-close": _vm.blur
        },
        model: {
          value: _vm.date,
          callback: function($$v) {
            _vm.date = $$v
          },
          expression: "date"
        }
      }),
      _vm._v(" "),
      _c("i", { staticClass: "material-icons warning" }, [_vm._v("warning")]),
      _vm._v(" "),
      _c("i", { staticClass: "material-icons calendar" }, [_vm._v("event")]),
      _vm._v(" "),
      _vm._t("help-text"),
      _vm._v(" "),
      _vm._t("errors")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f0df95b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f0df95b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/date-input.vue
// module id = null
// module chunks = 